import React from "react";
import { useTranslation } from "react-i18next";
import { useLanguageTheme } from "../../../../hooks/useLanguageTheme";
import { LightningBlock } from "./LightningBlock";

export const BenefitBlockMobile = ({
  benefitText,
}: {
  benefitText: string;
}) => {
  const { t } = useTranslation(["affiliates"]);
  const langTheme = useLanguageTheme();
  return (
    <div
      className="benefit-block-mobile-wrapper"
      style={{
        fontFamily: langTheme.mainFont(),
      }}
    >
      <div className="benefit-block-text">{t(benefitText)}</div>
      <LightningBlock />
    </div>
  );
};
